import eventBus from '@refapp/eventbus-js';

export default {
  data() {
    return {
      buynowData: null,
      variantDataLoaded: false,
      productItemId: '',
    };
  },
  methods: {
    getdata(values) {
      fetch(
        `/refapp/multipleclicktobuy/getretailers?productItemId=${values.productItemId}&varintItemId=${values.varintItemId}`,
      )
        .then((resp) => {
          if (!resp.ok) throw new Error(`HTTP error ${resp.status}`);
          return resp.json();
        })
        .then((data) => {
          this.buynowData = JSON.parse(data.Json);
          this.variantDataLoaded = !!this.buynowData;
          if (!this.variantDataLoaded) {
            throw new Error(data.ErrorMessage);
          }
        })
        .catch((error) => {
          this.variantDataLoaded = false;
          console.error('MCTB: /getretailers error:', error);
        });
    },
  },
  created() {
    eventBus.on('rfp-mctb-has-variant-component', (val) => this.getdata(val));
    window.eventBus.$on('rfp-mctb-has-variant-component', (val) => this.getdata(val));

    eventBus.on('this.datas.Product.ProductId', (val) => (this.productItemId = val));
    window.eventBus.$on('this.datas.Product.ProductId', (val) => (this.productItemId = val));
  },
};
